import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type { SingleSubscriptionCreditOptionsResponse } from 'types/entityTypes/SubscriptionCreditOptions'

const getSubscriptionCreditOptions = (
  subscriptionCreditOptionsByID: string | undefined
) => {
  const url = generateURL(
    SPARK_RESOURCE_TYPES.SUBSCRIPTION_CREDIT_OPTIONS,
    [],
    subscriptionCreditOptionsByID
  )
  return fetchWrapper<SingleSubscriptionCreditOptionsResponse>({
    url: url,
    method: 'GET',
  })
}

export function useSubscriptionCreditOptionsByID(
  subscriptionCreditOptionsByID: string | undefined
) {
  const response = useQuery(
    ['subscriptionCreditOptions', subscriptionCreditOptionsByID],
    () => getSubscriptionCreditOptions(subscriptionCreditOptionsByID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch subscription credit options: ${error.message}`
          )
        }
      },
      enabled: Boolean(subscriptionCreditOptionsByID),
      ...INFINITE_CACHE_AND_STALE_TIME,
    }
  )

  const { data: subscriptionCreditOption } = response.data || {}

  return {
    subscriptionCreditOption,
    ...response,
  }
}
